import { render, staticRenderFns } from "./work-order-notes.html?vue&type=template&id=1fd4568c&scoped=true&"
import script from "./work-order-notes.js?vue&type=script&lang=js&"
export * from "./work-order-notes.js?vue&type=script&lang=js&"
import style0 from "./WorkOrderNotes.vue?vue&type=style&index=0&id=1fd4568c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd4568c",
  null
  
)

export default component.exports